import { Filter, FilterType } from '@dfl/mui-admin-layout';
import { createdATFilter } from 'modules/common/constants/filters/common.filters';
import { getProviderLogisticFilter, getSupplierFilter, getVisibleFilter } from 'modules/common/constants/filters';
import { addressFilters } from 'lib/dfl-address-filter/filters';

const visibleFilter = getVisibleFilter('visible');
const logisticFilter = getProviderLogisticFilter('logistic._id');
const supplierFilter = getSupplierFilter('supplier._id');

const supplierLogisticFilter = getProviderLogisticFilter('warehouse.logistic._id');

const warehouseAddressFilter = addressFilters({
  countryFilter: 'warehouse:address.country',
  countryKey: 'country',
  countryField: 'address.country',
  stateFilter: 'warehouse:address.state',
  stateKey: 'state',
  stateField: 'address.state',
  cityFilter: 'warehouse:address.city',
  cityKey: 'city',
  cityField: 'address.city',
  justUseFor: 'CU',
});

const CommissionFilter: Filter = {
  filter: 'supplier:fields.commission',
  translate: true,
  type: FilterType.NUMBER,
  key: 'commission',
  field: 'priceConfig.value',
};

// warehouses list
export const warehouseFilters: Filter[] = [logisticFilter, ...warehouseAddressFilter, visibleFilter, createdATFilter];

// warehouses list
export const supplierWarehouseFilters: Filter[] = [
  supplierLogisticFilter,
  ...warehouseAddressFilter,
  visibleFilter,
  createdATFilter,
];

// inventory/warehouses/:id/supplier
export const warehouseSupplierFilters = [CommissionFilter, visibleFilter, supplierFilter, createdATFilter];

// /inventory/distribution-centers/:id/warehouses
export const distributionCenterWarehouseFilters = warehouseFilters;

export const defaultWarehouseFilters: Filter[] = [logisticFilter, visibleFilter, createdATFilter];
